/* Louzan — polish layer
   1. Staggered scroll-reveal (product grid + any [data-lz-reveal])
   2. Gold "added to cart" toast bar
   3. Mobile: cart icon goes to the full cart page instead of the drawer
   Reveal effects respect prefers-reduced-motion; the toast and the
   mobile cart behaviour work regardless. */
(function () {
  'use strict';

  var REVEAL_SELECTOR = '.product-grid__item, [data-lz-reveal]';
  var MOBILE_QUERY = '(max-width: 749px)';

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart';
  }

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  /* ── 1. Scroll reveal ─────────────────────────────────────────────── */
  function initReveal() {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) return;

    document.documentElement.classList.add('lz-anim');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lz-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    function prime(scope) {
      var items = (scope || document).querySelectorAll(
        '.product-grid__item:not([data-lz-primed]), [data-lz-reveal]:not([data-lz-primed])'
      );
      var batchIndex = 0;
      items.forEach(function (el) {
        el.setAttribute('data-lz-primed', '');
        /* keep an author-set stagger if the markup provided one */
        if (!el.style.getPropertyValue('--lz-stagger')) {
          el.style.setProperty('--lz-stagger', String(batchIndex % 8));
        }
        batchIndex++;
        io.observe(el);
      });
    }

    prime(document);

    /* new items from infinite scroll / filtering */
    var scope =
      document.querySelector('results-list') ||
      document.querySelector('.product-grid-container') ||
      document.body;
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          prime(scope);
          break;
        }
      }
    });
    mo.observe(scope, { childList: true, subtree: true });

    function revealAll() {
      document.querySelectorAll(REVEAL_SELECTOR).forEach(function (el) {
        el.classList.add('lz-in');
      });
    }

    /* safety net: anything still hidden after 4s gets revealed */
    setTimeout(revealAll, 4000);

    /* keep revealing on bfcache restore (iOS back button) */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) revealAll();
    });
  }

  /* ── 2. Added-to-cart toast ───────────────────────────────────────── */
  function initToast() {
    var toast = null;
    var hideTimer = null;

    function build() {
      if (toast) return toast;
      toast = document.createElement('div');
      toast.className = 'lz-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML =
        '<span class="lz-toast__check" aria-hidden="true">' +
        '<svg width="12" height="10" viewBox="0 0 12 10" fill="none">' +
        '<path d="M1 5.2 4.4 8.6 11 1.6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg></span>' +
        '<span class="lz-toast__text">Added to your cart</span>' +
        '<button type="button" class="lz-toast__action">View cart</button>' +
        '<button type="button" class="lz-toast__close" aria-label="Dismiss">' +
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none">' +
        '<path d="M1.5 1.5l9 9m0-9-9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg></button>';
      document.body.appendChild(toast);

      toast.querySelector('.lz-toast__action').addEventListener('click', function () {
        hide();
        if (isMobile()) {
          window.location.href = cartUrl();
          return;
        }
        var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
        if (trigger) {
          trigger.click();
        } else {
          window.location.href = cartUrl();
        }
      });
      toast.querySelector('.lz-toast__close').addEventListener('click', hide);
      return toast;
    }

    function show() {
      var el = build();
      clearTimeout(hideTimer);
      /* force a restart of the transition when fired back-to-back */
      el.classList.remove('lz-toast--visible');
      void el.offsetHeight;
      el.classList.add('lz-toast--visible');
      hideTimer = setTimeout(hide, 4000);
    }

    function hide() {
      clearTimeout(hideTimer);
      if (toast) toast.classList.remove('lz-toast--visible');
    }

    document.addEventListener('cart:update', function (e) {
      var data = e && e.detail && e.detail.data;
      if (!data) return;
      if (data.source !== 'product-form-component') return;
      if (data.didError) return;
      show();
    });
  }

  /* ── 3. Mobile: cart icon → full cart page ────────────────────────── */
  function initMobileCartLink() {
    document.addEventListener(
      'click',
      function (e) {
        if (!isMobile()) return;
        var target = e.target && e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"]');
        if (!target) return;
        e.preventDefault();
        e.stopPropagation();
        window.location.href = cartUrl();
      },
      true
    );
  }

  initReveal();
  initToast();
  initMobileCartLink();
})();
